import React from 'react';
import { Localization } from "@viamap/viamap2-common";
import { MIBIcon } from 'src/componentsUtils/MIBIcon';

export function ActionSelector(props: { activeTool: string, setActiveTool: (s: string) => void, onCapture?: () => void, children?: React.ReactNode }) {
   const { activeTool, setActiveTool, onCapture, children } = props;
   return (
      <div className="Horizontal_Radio_Button_group">
         <button data-info={Localization.getText("Inactive")} className={activeTool == "none" ? "active" : ""} onClick={() => setActiveTool("none")} ><MIBIcon icon="block" /></button>
         <button data-info={Localization.getText("Move")} className={activeTool == "move" ? "active" : ""} onClick={() => setActiveTool("move")} ><MIBIcon icon="move" /></button>
         <button data-info={Localization.getText("Rotate")} className={activeTool == "rota" ? "active" : ""} onClick={() => setActiveTool("rota")} ><MIBIcon icon="rotate" /></button>

         {children ? (
            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>{children}</div>
         ) : (
            <button data-info={Localization.getText("Capture")} style={{ marginLeft: "auto" }} onClick={() => onCapture && onCapture()} ><MIBIcon icon="adjustToScreen" /></button>
         )}
      </div>
   )
}

export default ActionSelector;
